import { useEffect, useRef } from "react";

import { useMessageBus } from "@jti/fe-message-bus";
import { useDispatch, useSelector } from "@jti/store/reduxHooks";
import { addProductToCart, fetchTrialCart } from "@jti/store/slices/cartSlice";

export const useProductListener = (): void => {
  const cart = useSelector((store) => store.cart);
  const cartRef = useRef(cart);
  const dispatch = useDispatch();
  const messageBus = useMessageBus();

  cartRef.current = cart;

  useEffect(() => {
    messageBus.subscribe({
      channel: "cart.add",
      callback: ({ payload: { sku, bundle, quantity, isFreeTrial, isConsentGiven, requestId } }) => {
        if (!cartRef.current.id) {
          messageBus.publish("fail.cart.add", {
            payload: { message: "productdetails.addproduct.error.cartId", requestId },
          });

          return;
        }

        if (!sku) {
          messageBus.publish("fail.cart.add", {
            payload: { message: "productdetails.addproduct.error.skuRequired", requestId },
          });

          return;
        }

        if (isFreeTrial) {
          dispatch(
            fetchTrialCart({
              useAnonymous: true,
              freeTrialProduct: {
                sku,
                bundle,
                requestId,
              },
            })
          );

          return;
        }

        dispatch(
          addProductToCart({
            cartId: cartRef.current.id,
            sku,
            bundle,
            quantity,
            isConsentGiven,
            requestId,
          })
        );
      },
    });

    return () => {
      messageBus.unsubscribe("cart.add");
      messageBus.removeHistoryItem("cart.add");
    };
  }, []);
};
